module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-PranceAroundTown-640.180b426a.jpg";